export const dynamicPricing = {
  title: "Dynamic Pricing",
  loading: "Loading settings…",
  status: {
    active: "On",
    inactive: "Off",
  },
  close: "Close",
  unit: {
    label: "Accommodation",
    autoPill: "✦ Auto from your history",
  },
  tabs: {
    calendario: "Calendar",
    precio: "Base price",
    reglas: "Rules",
    aplicacion: "Application",
  },
  weekdaysShort: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },
  cal: {
    stats: {
      adr: "Proj. ADR",
      occupancy: "Occupancy",
      revenue: "Revenue",
    },
    calculating: "Calculating prices…",
    minStayShort: "min. {count}n | min. {count}n",
  },
  legend: {
    low: "Low",
    base: "Base",
    high: "High",
    peak: "Peak",
    booked: "Booked",
    override: "Fixed",
  },
  why: {
    title: "Why {price} {curr} · {day}",
    chip: "explanation",
    nights: "{count} night | {count} nights",
    minStay: "Minimum stay: {nights} · floor {floor} / cap {ceil} {curr}",
    hint: "Tap a day to see how its price breaks down.",
  },
  apply: {
    diffPrefix: "With the suggested prices:",
    diffSuffix: "versus your current prices for {month}.",
    apply: "Apply prices",
    applying: "Applying…",
    applyNow: "Apply now",
    enableToApply: "Turn on Dynamic Pricing to apply.",
    enableFirst: "Turn on Dynamic Pricing first.",
    autoNote: {
      prefix: "✓ In",
      mode: "Automatic",
      mid: "mode, prices apply",
      everyday: "every day",
    },
    result: {
      hotelPending: "Hotels (multiple units) aren't supported yet in this phase.",
      ok: "✓ Applied {count} day ({from} → {to}) and sent to channels. | ✓ Applied {count} days ({from} → {to}) and sent to channels.",
      failed: "Couldn't apply the prices.",
    },
  },
  base: {
    title: "Base price and limits",
    desc: "Suggested from your history. The engine never leaves this range.",
    basePerNight: "Base / night",
    min: "Minimum (floor)",
    max: "Maximum (cap)",
    rounding: "Rounding",
  },
  rounding: {
    integer: "Whole",
    ends0: "Ends in 0",
    ends9: "Ends in 9",
    multiple5: "Mult. 5",
  },
  weekend: {
    title: "Weekend and minimum stay",
    upliftLabel: "Weekend uplift",
    daysLabel: "Weekend days:",
    minStayLabel: "Minimum stay (nights)",
    minStayNormal: "Standard",
    minStayWeekend: "Weekends / high",
    orphanTitle: "Fill orphan nights",
    orphanDesc: "Shorter stays ({pct}% off) in 1–2 night gaps.",
  },
  demand: {
    title: "Demand sensitivity",
    desc: "How much occupancy and booking pace move the price.",
  },
  aggr: {
    low: "Conservative",
    medium: "Medium",
    high: "Aggressive",
  },
  seasons: {
    title: "Seasons",
    namePlaceholder: "Name",
    monthDayPlaceholder: "MM-DD",
    add: "+ Add season",
  },
  events: {
    title: "Events (fairs, festivals…)",
    suggestWithAI: "✨ Suggest with AI",
    suggesting: "Searching…",
    namePlaceholder: "Name",
    datePlaceholder: "YYYY-MM-DD",
    empty: "No events. Add them manually or with AI.",
    add: "+ Add event",
    suggestionsHead: "AI suggestions{city} — review dates and add",
    addSuggestion: "+ Add",
    noSuggestions: "No suggestions (check that the accommodation has a city set).",
  },
  demandRules: {
    title: "Demand rules",
    lastMinuteTitle: "Last-minute discounts",
    lastMinuteDesc: "Lowers the price of nearby dates still open.",
    holidaysTitle: "Automatic holidays",
    holidaysDesc: "Applies +{pct}% on national holidays.",
    occupancyTitle: "Raise by occupancy",
    occupancyDesc: "If the month is over {threshold}% full, raise the price.",
    weeklyDiscount: "Weekly disc. (7+) %",
    monthlyDiscount: "Monthly disc. (28+) %",
  },
  application: {
    title: "Mode and sync",
    modeLabel: "Application mode",
    modeSuggested: "Suggested (I review first)",
    modeAuto: "Automatic",
    syncTitle: "Sync to channels (Channex → Airbnb / Booking)",
    syncDesc: "Publishes the calculated prices to your channels.",
    horizonLabel: "Calculation horizon",
    horizonMonths: "{count} months",
  },
  save: {
    saved: "Saved ✓",
    saving: "Saving…",
    save: "Save changes",
  },
  errors: {
    forbidden: "You don't have access to this accommodation.",
    loadFailed: "Couldn't load the settings.",
    saveFailed: "Couldn't save. Check the fields.",
  },
};
